import React from "react";
import ContactDetails from "../components/common/ContactPage/ContactDetails";
import ContactForm from "../components/common/ContactPage/ContactForm";
import Footer from '../components/common/Footer'

const Contact = () => {
  return (
    <>
      <div className="mx-auto mt-20 flex w-11/12 max-w-maxContent flex-col justify-between gap-10 text-richblue-700 lg:flex-row">
        {/* Contact Details */}
        <div className="lg:w-[40%]">
          <ContactDetails />
        </div>

        {/* Contact Form */}
        <div className="lg:w-[60%]">
          <ContactForm />
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default Contact;
